import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FileText, Image, Video, Paperclip } from 'react-feather';
import * as AttachmentUtils from '../../helpers/AttachmentUtils';

const getFileIcon = (type, size) => {
  const iconSize = size ? size : 24;

  if (type.startsWith('image')) {
    return <Image size={iconSize} data-qa="file-icon-image" />;
  } else if (type.startsWith('video') && AttachmentUtils.isSupportedVideoStreamType(type)) {
    return <Video size={iconSize} data-qa="file-icon-video" />;
  } else if (type === 'application/pdf') {
    return <FileText size={iconSize} data-qa="file-icon-pdf" />
  }

  return <Paperclip size={iconSize} data-qa="file-icon-paperclip" />;
};

const FileIcon = ({ type, size }) => (
		<Fragment>
      {getFileIcon(type, size)}
		</Fragment>
);

FileIcon.propTypes = {
  type: PropTypes.string.isRequired,
  size: PropTypes.number
};

export default FileIcon;